import { graphqlApolloClient } from "../graphql-apollo-client"
import { user } from "../../graphql"
import { CREATE_IMPLEMENTER_ACCOUNT } from "./gql/create-implementer-account"
import { GET_IMPLEMENTER_ACCOUNTS } from "./gql/get-implementer-accounts"
import { GET_IMPLEMENTER_PROJECTS } from "./gql/getImplementerProjects"
import { GET_ACCOUNT_IMPLEMENTER_BY_UID } from "./gql/get-account-implementer-by-uid"
import { DELETE_IMPLEMENTER_ACCOUNT } from "./gql/delete-implementer-account"
import { CHECK_TRUSTED_DEVICE } from "./gql/getCheckDevice"

export const AccountService = () => {
  const recoveryAccountPassword = async ({ email }) => {
    const result = await graphqlApolloClient.mutate({
      mutation:  user.mutations.recoveryAccountPassword,
      variables: { email }
    })
    return result?.data?.RecoveryPassword
  }

  const updateAccount = async ({ id, data }) => {
    const result = await graphqlApolloClient.mutate({
      mutation:  user.mutations.updateAccount,
      variables: { id, data }
    })
    return result?.data?.UpdateAccount
  }

  const disabledAccount = async ({ id, disabled }) => {
    const result = await graphqlApolloClient.mutate({
      mutation:  user.mutations.disabledAccount,
      variables: { id, disabled }
    })
    return result?.data?.DisabledAccount
  }

  const createImplementerAccount = async ({ data, implementerId }) => {
    const result = await graphqlApolloClient.mutate({
      mutation: CREATE_IMPLEMENTER_ACCOUNT,
      variables: { data, implementerId }
    })
    return result?.data?.CreateImplementerAccount
  }

  const getImplementerAccounts = async ({ implementerId }) => {
    const result = await graphqlApolloClient.query({
        query: GET_IMPLEMENTER_ACCOUNTS,
        fetchPolicy: "network-only",
        variables: { implementerId }
      }
    )
    return result?.data?.ImplementerAccounts
  }

  const getImplementerProjects = async ({ implementerId }) => {
    const result = await graphqlApolloClient.query({
        query: GET_IMPLEMENTER_PROJECTS,
        fetchPolicy: "network-only",
        variables: { implementerId }
      }
    )
    return result?.data?.ImplementerProjects
  }

  const getAccountImplementerByUid = async ({ uid }) => {
    const { data } = await graphqlApolloClient.query({
        query: GET_ACCOUNT_IMPLEMENTER_BY_UID,
        fetchPolicy: "network-only",
        variables: { uid }
      }
    )
    return data?.ImplementerByUid
  }

  const deleteImplementerAccount = async ({ id }) => {
    const result = await graphqlApolloClient.mutate({
        mutation: DELETE_IMPLEMENTER_ACCOUNT,
        variables: { id }
      }
    )

    return result?.data?.DeleteImplementerAccount
  }

  const checkTrustedDevice = async (deviceId) => {
    const result = await graphqlApolloClient.query({
      query: CHECK_TRUSTED_DEVICE,
      variables: {
        deviceId
      },
      fetchPolicy: "no-cache",
    });
  
    return result?.data?.checkTrustedDevice;
  }

  return {
    updateAccount,
    disabledAccount,
    getImplementerAccounts,
    recoveryAccountPassword,
    createImplementerAccount,
    deleteImplementerAccount,
    getAccountImplementerByUid,
    getImplementerProjects,
    checkTrustedDevice, 
  }
}
